// extracted by mini-css-extract-plugin
export default {"container":"voucher-form-submit_container__Aq9O2"};